import { Campaign, CampaignTypes } from '~/types';
import { useQuery } from '~/utils/rq';

const getBaseUrl = (type: CampaignTypes) => {
  if (type === CampaignTypes.SERVICE) {
    return '/internal/admin/services/campaigns';
  }

  //@NOTE: We need to retrieve all campaign data for tracking only studies due to the meta properties in the provider
  return '/campaigns';
};

export type CampaignResponse = Campaign;

export const useFetchCampaign = (type: CampaignTypes, campaignId?: string) => {
  const BASE_URL = getBaseUrl(type);

  const qs =
    type === CampaignTypes.SOFTWARE ? '?include_baseline_questions=true' : '';

  const URL = `${BASE_URL}/${campaignId}${qs}`;

  return useQuery<CampaignResponse>(
    {
      queryKey: [URL],
      enabled: !!campaignId
    },
    {
      method: 'get',
      url: URL
    }
  );
};
